<template>
  <div class="rkld">
    <div class="rkldRight">
      <div class="rkldRightContent">
        <!-- tabs导航 -->
        <el-tabs v-model="editableTabsValue" type="card">
          <el-tab-pane label="信息服务工单" name="1">
            <!--搜索框-->
            <div class="searchTj">
              <div class="searchTjHead">
                <span>查询条件</span>
                <!-- <el-button
                                    style="
                                        float: right;
                                        padding: 3px 0;
                                        color: #000;
                                    "
                                    type="text"
                                    @click.native="Resert"
                                >
                                    <i class="el-icon-refresh"></i>
                                    刷新页面
                                </el-button> -->
                <i
                  class="searchDomw"
                  @click="searchValue = !searchValue"
                  :class="
                    searchValue == true
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  "
                ></i>
              </div>
              <el-form
                :model="form"
                class="searchTjContent"
                label-width="100px"
                v-show="searchValue"
              >
                <el-row>
                  <el-col :span="5">
                    <el-form-item label="姓名">
                      <el-input
                        v-model="form.customerName"
                        placeholder="请输入"
                        class=""
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="生活区域">
                      <el-select
                        v-model="form.lifeArea"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option label="农村" value="2"></el-option>
                        <el-option label="城市" value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="老人类别">
                      <el-select
                        v-model="form.elderlyBelongCategory"
                        placeholder="请选择"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="(item, index) in oldtypeLits"
                          :key="index"
                          :label="item.dictLabel"
                          :value="item.dictCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="所属机构">
                      <el-select
                        placeholder="请选择所属机构"
                        v-model="form.serviceStation"
                      >
                        <el-option
                          v-for="item in optionsType"
                          :key="item.id"
                          :label="item.statName"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-show="searchValue">
                  <el-col :span="22">
                    <el-form-item label="用户类型">
                      <el-select
                        v-model="form.minzhengIndex"
                        placeholder="请选择老人类型"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="(item, index) in usertypeList"
                          :key="index"
                          :label="item.dictLabel"
                          :value="item.dictCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div v-show="searchValue">
                  <el-button type="primary" class="searchBtns" @click="showlist"
                    >查询</el-button
                  >
                  <el-button type="info" class="resetReach" @click="resert"
                    >重置</el-button
                  >
                </div>
                <div class="searchTjContentDiv" v-show="searchValue"></div>
                <div class="searchTjContentDiv" v-show="searchValue"></div>
                <!-- <div
                                    class="arrowDown"
                                    @click="showSearch"
                                    style="color: #000"
                                >
                                    <i class="el-icon-arrow-down"></i>
                                </div> -->
              </el-form>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
              <el-button-group>
                <el-button
                  type="primary"
                  icon="el-icon-refresh"
                  class="dropRests"
                  @click="resertTable"
                ></el-button>
                <!-- <el-button type="primary"> -->
                <el-dropdown
                  class="dropdown"
                  trigger="click"
                  :hide-on-click="false"
                >
                  <span class="el-dropdown-link">
                    <i
                      class="el-icon-s-grid el-icon--right"
                      style="color: #fff"
                    ></i>
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <template>
                        <el-checkbox-group
                          v-model="checkList"
                          :min="1"
                          @change="tableShow"
                        >
                          <el-checkbox label="序号">序号</el-checkbox><br />
                          <el-checkbox label="姓名">姓名</el-checkbox><br />
                          <el-checkbox label="年龄">年龄</el-checkbox><br />
                          <el-checkbox label="性别">性别</el-checkbox><br />
                          <el-checkbox label="手机号码">手机号码</el-checkbox
                          ><br />
                          <el-checkbox label="用户类型">用户类型</el-checkbox
                          ><br />
                          <el-checkbox label="老人类别">老人类别</el-checkbox
                          ><br />
                          <el-checkbox label="开始时间">开始时间</el-checkbox
                          ><br />
                          <el-checkbox label="居住地址">居住地址</el-checkbox
                          ><br />
                          <el-checkbox label="操作">操作</el-checkbox><br />
                        </el-checkbox-group>
                      </template>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-button-group>
            </div>

            <!--表单-->
            <div class="addForm">
              <el-table
                ref="multipleTable"
                :data="tableDate"
                tooltip-effect="dark"
                :header-cell-style="{
                  background: '#e6e6e6',
                  color: '#000',
                }"
                border
              >
                <el-table-column
                  type="index"
                  width="70"
                  label="序号"
                  align="center"
                  v-if="no1"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="customerName"
                  label="姓名"
                  align="center"
                  v-if="no2"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="age"
                  label="年龄"
                  align="center"
                  show-overflow-tooltip
                  v-if="no3"
                >
                </el-table-column>
                <el-table-column
                  prop="gender"
                  label="性别"
                  align="center"
                  show-overflow-tooltip
                  v-if="no4"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.gender == 0">男</span>
                    <span v-if="scope.row.gender == 1">女</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="手机号码"
                  align="center"
                  show-overflow-tooltip
                  v-if="no5"
                >
                </el-table-column>
                <el-table-column
                  prop="elderlyBelongCategory"
                  label="老人类别"
                  align="center"
                  show-overflow-tooltip
                  v-if="no6"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(item, index) in oldtypeLits"
                      :key="index"
                      v-if="scope.row.elderlyBelongCategory == item.dictCode"
                      >{{ item.dictLabel }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="minzhengIndex"
                  label="用户类型"
                  align="center"
                  show-overflow-tooltip
                  v-if="no7"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      v-if="scope.row.minzhengIndex == item.dictCode"
                      >{{ item.dictLabel }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="startTime"
                  label="开始时间"
                  align="center"
                  show-overflow-tooltip
                  v-if="no9"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="居住地址"
                  align="center"
                  show-overflow-tooltip
                  v-if="no9"
                >
                </el-table-column>
                <el-table-column label="操作" align="center" v-if="no8">
                  <template slot-scope="scope">
                    <el-link
                      :underline="false"
                      class="span_icon"
                      @click="handleClick('查看', 1, scope.row)"
                      >查看</el-link
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      :title="dialogVisibleTitle"
      :visible.sync="dialogVisible"
      width="55%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <!--新增查看表单-->
        <div
          class="dialog_content_pane"
          v-show="stepIndex == 1 || stepIndex == 0"
        >
          <el-form
            label-width="110px"
            :model="formData"
            :rules="formDataRules"
            ref="formData"
          >
            <el-row>
              <el-col :span="16">
                <el-form-item label="姓名:">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.customerName"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="身份证号:">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.idCard"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="出生年月:">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.birthday"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="年龄:">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.age"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="height: 100px"> </el-col>
              <el-col :span="4">
                <el-upload
                  :action="actionUrl"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <div class="avatar" v-if="formData.photo">
                    <img :src="formData.photo" disabled />
                  </div>
                  <div v-else style="text-align: center; width: 178px">
                    <i
                      class="el-icon-plus avatar_uploader avatar-uploader-icon"
                    ></i>
                  </div>
                </el-upload>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="性别：">
                  <el-select
                    v-model="formData.gender"
                    placeholder="请选择"
                    style="width: 100%"
                    disabled
                  >
                    <el-option value="0" label="男"></el-option>
                    <el-option value="1" label="女"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="手机号：">
                  <el-input
                    placeholder="请输入"
                    v-model="formData.phone"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="民族：">
                  <el-select
                    v-model="formData.nation"
                    placeholder="请选择"
                    style="width: 100%"
                    disabled
                  >
                    <el-option :value="0" label="汉"></el-option>
                    <el-option :value="1" label="藏族"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="生活区域：">
                  <el-select
                    v-model="formData.lifeArea"
                    placeholder="请选择"
                    style="width: 100%"
                    disabled
                  >
                    <el-option label="农村" value="2"></el-option>
                    <el-option label="城市" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="老人类别：">
                  <el-select
                    v-model="formData.elderlyBelongCategory"
                    placeholder="请选择"
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in oldtypeLits"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="用户类型：">
                  <el-select
                    v-model="formData.minzhengIndex"
                    placeholder="请选择老人类型"
                    style="width: 100%"
                    disabled
                  >
                    <el-option
                      v-for="(item, index) in usertypeList"
                      :key="index"
                      :label="item.dictLabel"
                      :value="item.dictCode"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <div class="addressFrom">
                  <div class="addressTitle">
                    <span></span>
                  </div>
                  <div class="addressContent">
                    <div class="addressBox">
                      <div class="addressItem">
                        <el-form-item prop="provinceId">
                          <el-select
                            :disabled="
                              normalInfo.orgLevel == 1 ||
                              normalInfo.orgLevel == 2 ||
                              normalInfo.orgLevel == 3 ||
                              normalInfo.orgLevel == 4 ||
                              normalInfo.orgLevel == 5
                            "
                            v-model="formData.provinceId"
                            placeholder="请选择省"
                            @change="handleProvince"
                            ref="selectShengChange"
                          >
                            <el-option
                              v-for="(item, index) in provinceList"
                              :key="index"
                              :label="item.name"
                              :value="item.adcode"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="addressItem">
                        <el-form-item prop="cityId">
                          <el-select
                            :disabled="
                              normalInfo.orgLevel == 2 ||
                              normalInfo.orgLevel == 3 ||
                              normalInfo.orgLevel == 4 ||
                              normalInfo.orgLevel == 5
                            "
                            v-model="formData.cityId"
                            placeholder="请选择市"
                            @change="handleCity"
                            ref="selectShiChange"
                          >
                            <el-option
                              v-for="(item, index) in cityList"
                              :key="index"
                              :label="item.name"
                              :value="item.adcode"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="addressItem">
                        <el-form-item prop="areaId">
                          <el-select
                            :disabled="
                              normalInfo.orgLevel == 3 ||
                              normalInfo.orgLevel == 4 ||
                              normalInfo.orgLevel == 5
                            "
                            v-model="formData.areaId"
                            placeholder="请选择区"
                            @change="handleArea"
                            ref="selectQuChange"
                          >
                            <el-option
                              v-for="(item, index) in areaList"
                              :key="index"
                              :label="item.name"
                              :value="item.adcode"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="addressItem">
                        <el-form-item prop="streetId">
                          <el-select
                            :disabled="
                              normalInfo.orgLevel == 4 ||
                              normalInfo.orgLevel == 5
                            "
                            v-model="formData.streetId"
                            placeholder="请选择街道"
                            @change="streetChange"
                            ref="selectJiedaoChange"
                          >
                            <el-option
                              v-for="(item, index) in streetList"
                              :key="index"
                              :label="item.addName"
                              :value="item.addCode"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="addressItem">
                        <el-form-item prop="shequid">
                          <el-select
                            :disabled="normalInfo.orgLevel == 5"
                            v-model="formData.shequid"
                            @change="handleCommunityChange"
                            placeholder="请选择社区"
                            ref="selectShequChange"
                          >
                            <el-option
                              v-for="item in communityList"
                              :key="item.id"
                              :label="item.address"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                    <el-form-item prop="address">
                      <input
                        v-model.trim="formData.address"
                        :disabled="dialogTitle == '查看'"
                        id="tipinput"
                        class="el-input__inner"
                        :class="dialogTitle == '查看' ? 'innerCur' : ''"
                        @focus="getMap('tipinput')"
                        placeholder="请输入关键字"
                        autocomplete="off"
                      />
                    </el-form-item>
                    <div class="map_container">
                      <div
                        id="container"
                        style="width: 100%; height: 300px"
                      ></div>
                    </div>
                  </div>
                </div>
                <el-form-item label="居住情况：">
                  <el-radio-group v-model="formData.liveCondition" disabled>
                    <el-radio label="4">独自居住</el-radio>
                    <el-radio label="5">与配偶居住</el-radio>
                    <el-radio label="3">与子女同住</el-radio>
                    <el-radio label="6">其他</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="经济来源：">
                  <el-checkbox-group v-model="formData.economicSource" disabled>
                    <el-checkbox label="0">养老金</el-checkbox>
                    <el-checkbox label="1">子女供养</el-checkbox>
                    <el-checkbox label="2">救济优抚</el-checkbox>
                    <el-checkbox label="3">兼职</el-checkbox>
                    <el-checkbox label="4">其他</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--回访内容表单-->
        <!-- <div class='dialog_content_pane' v-show='stepIndex == 2'>
            <el-form :model="formData" label-width="100px">
              <el-row>
                  <el-col :span="12">
                      <el-form-item label='老人姓名：'>
                          <el-input value='徐玉溪' class='none' v-model='formData.oldName' ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label='电话：'>
                        <el-input value='13955130219' class='none' v-model='formData.oldPhone'></el-input>
                        <img
                                    src="../assets/img/3.png"
                                    class="icon"
                                    alt=""
                                    @click='dialingOpt'
                                />
                      </el-form-item>
                  </el-col>
              </el-row>
            <template  v-for='(item, index) in currentZfEvaluateContentLis'>
               <div :key="index">
                    <el-form-item label='问题：'>
                       <el-input value='询问老人身体健康情况' class='none' v-model='formData.questionName' disabled></el-input>
                    </el-form-item>
                    <el-form-item label='是否选择：'>
                            <el-radio-group  v-model='formData.replySelection' @change="isSure"
                                        >
                                <el-radio label='0'>是</el-radio>
                                <el-radio label='1'>否</el-radio>
                            </el-radio-group>
                    </el-form-item>
                    <el-form-item label='原因：' v-if="isReason">
                        <el-input type="textarea" v-model='formData.reason'></el-input>
                    </el-form-item>
                    </div>
                    </template>
                    <el-form-item label='其他：'>
                        <el-input type="textarea" v-model='formData.other'></el-input>
                    </el-form-item>
                    </el-form>
             </div> -->
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            v-if="dialogVisibleTitle != '查看'"
            @click="submitForm"
            >确 定</el-button
          >
          <el-button @click="dialogVisibleClone">取 消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
  <!-- 新增功能模态框 -->
</template>
<script>
import common from "../../../utils/common.js"
import request from "@/utils/request.js"
import AMap from "AMap" // 引入高德地图
import baseURL from "@/api/baseURL"
import { discriCard, chekCode, chekPhone } from "@/views/elderManage/util.js"
export default {
  data() {
    return {
      orgList: [],
      arrOrgList: [],
      myMap: null,
      isdisabled: false,
      defaultProps: {
        children: "children",
        label: "label",
      },
      oldtypeLits: [],
      usertypeList: [],
      orgList: [],
      arrOrgList: [],
      currentZfEvaluateContentLis: [],
      dialogVisible10: false,
      dialogVisible11: false,
      // 图片预览
      dialogImageUrl: "",
      // 上传图片地址
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      dealForm: { handles: "", handlesPhoto: [] },
      dealImgs: [],
      dialogVisible: false, //table表单弹窗
      dialogVisibleTitle: "",
      formContent: {},
      isReason: false,
      formDataRules: {},
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      // 筛选数据功能按钮初始值
      checkList: [
        "序号",
        "服务类型",
        "老人类别",
        "区域",
        "开始时间",
        "结束时间",
        "走访进度",
        "处理人",
        "创建时间",
        "操作",
      ],

      // 表单测试数据
      tableDate: [],
      // 老人问题汇总
      visitDate: [
        {
          name: "夏立根",
          feedbackTime: "2020-12-19 20:10",
          feedbackContent: "",
          solve: 1,
        },
      ],
      // 回访进度
      scheduleData: [],
      addForm: {
        serviceType: "", //服务类型
        serviceDemand: [], //老人类别
        provinceId: "", //区域
        cityId: "", //区域
        areaId: "", //区域
        streetId: "", //区域
        shequid: "", //区域
        startTime: "", //开始时间
        endTime: "", //结束时间
        frequency: "", //频次
        interval: "", //间隔天数
        visitDuration: "", //探望时长
        department: "", //选择部门
        person: "", //选择人员
        health: "",
        // serviceDemand: [],
        selfCare: [],
        hraring: "",
        case: [],
        evaluateTypeId: null,
        shengjiId: "",
        shijiId: "",
        qujiId: "",
        stationId: "",
        shequjiId: "",
      },
      optionsType: [],
      // 筛选按钮
      no1: true,
      no2: true,
      no3: true,
      no4: true,
      no5: true,
      no6: true,
      no7: true,
      no8: true,
      no9: true,

      quanbu: true, // 搜素条件是否显示
      showVisit: false, // 探望时长显示与否

      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      total1: 0, //总数据
      searchValue: true,
      showSlide: true,
      editableTabsValue: "1",
      tabIndex: 1,
      input: "",
      value: "",
      valueSq: "",
      multipleSelection: [],
      pageNo: 1,
      pageSize: 10,
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1,
      },
      feedback: "",
      // addForm: {
      //     health: "",
      //     serviceDemand: [],
      //     selfCare: [],
      //     hraring: "",
      //     case: [],
      // },
      addForm1: {
        health: "0",
      },
      // 搜索
      form: {
        type: "",
        evaluateTypeId: "",
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible3: false,
      dialogVisible5: false,
      stepIndex: 1,
      twnrShow: false,
      dialogTitle: "",
      stepTitle: "",
      schedule: false,
      tableDate1: [],
      tableDate4: [],
      returnVisitForm1: "",
      returnVisitForm: {
        // 回访
        questionName1: "",
        replySelection1: "",
        reason1: "",
        questionName2: "",
        replySelection2: "",
        reason2: "",
        other: "",
      },
      formData: {
        //基本信息
        name: "", //姓名
        gender: "", //性别
        phone: "", //联系方式
        idCard: "", //身份证号
        age: "", //年龄
        birthday: "", // 出生年月
        phone: "", //老人类型
        provinceId: "", //省
        cityId: "", //市
        areaId: "", //区
        streetId: "", //街道
        shequid: "", //社区
        address: "", //居住地址
        startTime: "",
        photo: "", //图片
        nation: "", //民族
        liseArea: "",
        userType: "", //用户类型
        olderType: "", //老人类别
        liveCondition: "", //居住情况
        economicSource: [], //经济来源
        oldName: "", //老人姓名
        oldPhone: "", //老人电话
        question: "", //问题
        isSure: "",
        reason: "",
        other: "",
      },
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      olderVisible: false,
      detailsData: {
        serviceType: "",
        olderType: "",
        area: "",
        time: [],
        frequency: "",
        interval: "",
        department: "",
        handler: "",
        intervals: "",
      },
      servicelist: [], //服务类型
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      polygons: [],
      departmentDate: [], //部门列表
      personIdOptions: [], //人员列表
      assignForm: {
        //指派
        serverStationId: "",
        serverPersonId: "",
      },
      assignVisible: false,
      isMap: true,
      stepState: false,
      normalInfo: {},
    }
  },
  inject: ["reload"], //注入
  created() {
    this.getOrg()
    this.showlist()
    this.getProvince()
    this.getServiceStationList()
    this.gettypeList()
    this.getusertypeList()
  },
  methods: {
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "visiting_user_type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.usertypeList = res.rows
              this.usertypeList.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    gettypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
              this.oldtypeLits.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            this.changeFirst()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistrict(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistrict(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.from.latitude = item.center.lat
            this.form.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.form.addressLat = item.center.lat
            this.form.addressLng = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.form.addressLat = item.center.lat
            this.from.addressLng = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.adcode + index == this.normalInfo.streetId) {
            this.form.addressLat = item.latitude
            this.form.addressLng = item.longitude
          }
        })
      }
      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.form.provinceId = this.normalInfo.provinceId
      this.form.cityId = this.normalInfo.cityId
      this.form.areaId = this.normalInfo.areaId
      this.form.streetId = this.normalInfo.streetId
      this.form.shequid = this.normalInfo.communityId
      console.log(this.form.shequid, "99")
      this.addForm.provinceId = this.normalInfo.provinceId
      this.addForm.cityId = this.normalInfo.cityId
      this.addForm.areaId = this.normalInfo.areaId
      this.addForm.streetId = this.normalInfo.streetId
      this.addForm.shequid = this.normalInfo.communityId

      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索条件
    showSearch() {
      this.searchValue = !this.searchValue
    },

    // 筛选功能按钮
    tableShow() {
      if (this.checkList.length > 0) {
        if (this.checkList.findIndex((obj) => obj == "序号") == -1) {
          this.no1 = false
        } else {
          this.no1 = true
        }
        if (this.checkList.findIndex((obj) => obj == "服务类型") == -1) {
          this.no2 = false
        } else {
          this.no2 = true
        }
        if (this.checkList.findIndex((obj) => obj == "老人类别") == -1) {
          this.no3 = false
        } else {
          this.no3 = true
        }
        if (this.checkList.findIndex((obj) => obj == "区域") == -1) {
          this.no4 = false
        } else {
          this.no4 = true
        }
        if (this.checkList.findIndex((obj) => obj == "开始时间") == -1) {
          this.no5 = false
        } else {
          this.no5 = true
        }
        if (this.checkList.findIndex((obj) => obj == "结束时间") == -1) {
          this.no6 = false
        } else {
          this.no6 = true
        }
        if (this.checkList.findIndex((obj) => obj == "走访进度") == -1) {
          this.no7 = false
        } else {
          this.no7 = true
        }
        if (this.checkList.findIndex((obj) => obj == "处理人") == -1) {
          this.no9 = false
        } else {
          this.no9 = true
        }
        if (this.checkList.findIndex((obj) => obj == "操作") == -1) {
          this.no8 = false
        } else {
          this.no8 = true
        }
      }
    },

    //加载地图
    loadmap(index) {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map(index, {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    // 地址 start
    //获取省级
    async getProvince() {
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //获取地址
    getDistrict(name = "中国") {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (err) {
                console.log(err)
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })

                self.polygons.push(self.polygon)
              }
              try {
                self.myMap.add(self.polygons)
              } catch (err) {
                console.log(err)
              }
              // self.myMap.setFitView(); //地图自适应
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.formData.shiId = ""
      this.formData.quId = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.formData.quId = ""
      this.areaList = []
      this.streetList = []
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      // val = val.replace(/.$/, "");
      this.formData.shequid = ""
      this.formData.streetId = ""
      let streetList = await this.getStreetList(val)
      this.streetList = streetList
      console.log("111", this.streetList)
    },
    //街道地址发生变化
    async streetChange(val) {
      this.formData.shequid = ""
      let communityList = await this.getCommityList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    async handleStep(index) {
      let self = this
      this.stepIndex = index
    },

    // 拨号 先置忙再外呼 外地手机号要加0
    dialingOpt() {
      const that = this
      that.isDial = false
      let agentState = that.getAgentStateOpt()
      // 坐席状态为4=置忙 可外呼  需先置忙，在外呼
      if (agentState != "4" && agentState != "5") {
        that.statesStatusChange("4")
      }
      if (that.aghentPhone != null && that.aghentPhone != "") {
        console.log(that.aghentPhone)
        // 坐席外呼
        var r = that.callTool.Dial(that.aghentPhone.trim())
        console.log(r)
        // alert("坐席外呼返回事件，返回值=" + r);
        if (!r) {
          that.$message({
            showClose: true,
            message: "外拨失败-1",
            type: "error",
            offset: 50,
          })
          // 坐席外呼失败 取消外呼 调用该方法后会触发事件 线路状态改变 OnLineStateChanged
          that.callTool.CancelDial()
          that.onLineStateChangedOpt()
          that.statusDic = "2"
        } else {
          // alert('外呼成功 外呼号码' + that.aghentPhone)
          // 坐席呼出后触发该事件 呼出结果（TRUE=成功、FALSE=失败）
          that.callTool.OnAgentDial((bResult) => {
            console.log(bResult)
            // alert('bResult外呼后返回值' + bResult)
            if (!bResult) {
              that.$message({
                showClose: true,
                message: "外拨失败-2",
                type: "error",
                offset: 50,
              })
              that.callTool.CancelDial()
              that.onLineStateChangedOpt()
              that.statusDic = "2"
            } else {
              that.stateId = "3"
              that.createState("3")
              that.statusDic = "3"
              // 坐席外呼接通
              that.callTool.OnDialConnected()
            }
          })
        }
      } else {
        that.$message({
          showClose: true,
          message: "请输入需要外拨的号码",
          type: "error",
          offset: 50,
        })
      }
    },

    // 图片上传 start
    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.img = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
        return
      }
    },
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 图片上传 end

    // 弹框关闭
    handleClose() {
      this.dialogVisible = false
    },

    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.formData.areaId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.addressLng = e.poi.location.lng
        self.formData.addressLat = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData.addressLng),
          Number(self.formData.addressLat),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },

    //获取地址
    getMaps(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 弹窗
    async handleClick(title, index, row = {}) {
      let self = this
      self.dialogVisibleTitle = title
      self.dialogVisible = true
      self.stepIndex = index
      self.currentStepIndex = index
      self.currentRow = row

      //  setTimeout(async () => {
      //     await self.$nextTick(() => self.loadmap('container'))
      // }, 30)
      this.formData = row
      this.formData.addressLng = row.addressLng
      this.formData.addressLat = row.addressLat
      this.formData.economicSource = row.economicSource.split(",")
      let jsonTemp = { ...row }
      self.formData.streetId = String(jsonTemp.streetId)
      self.formData.shequid = Number(jsonTemp.shequid)
      if (!jsonTemp.provinceId) return
      let city = await self.getDistrict(jsonTemp.provinceId)
      self.cityList = city.districtList
      if (!jsonTemp.cityId) return
      let area = await this.getDistrict(jsonTemp.cityId)
      self.areaList = area.districtList
      if (!jsonTemp.areaId) return
      let streetList = await this.getStreetList(jsonTemp.areaId)
      self.streetList = streetList
      if (!jsonTemp.streetId) return
      let communityList = await self.getCommityList(jsonTemp.streetId)
      self.communityList = communityList
      setTimeout(async () => {
        await self.$nextTick(() => {
          self.loadmap("container")
          self.potintMap()
        })
      }, 30)
      this.$forceUpdate()
      switch (self.stepIndex) {
        case 1:
          self.stepIndex = 0
          // this.look(row)
          break
        case 2:
          self.stepIndex = 1
          this.look(row)
          break
      }
    },
    dialogVisibleClone() {
      this.dialogVisible = false
      this.$refs.formData.resetFields()
    },
    submitForm() {
      this.dialogVisible = false
      this.$refs.formData.resetFields()
    },
    // 查看
    look(date) {
      let params = {
        id: date.id,
        pageNo: 1,
        pageSize: 100,
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfevaluateType/info/getById",
        method: "POST",
        data: params,
      }).then(async (res) => {
        console.log(res)
        this.currentZfEvaluateContentLis = res.content.zfEvaluateContentList
      })
    },
    isSure(val) {
      if (val == 1) {
        this.isReason = true
      } else {
        this.isReason = false
      }
    },
    // 获取数据
    getServiceStationList() {
      let params = {
        pageNo: 1,
        pageSize: 1000,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.optionsType = []
              return
            }
            this.optionsType = res.content.list
          }
        })
    },

    // 重置
    resert() {
      this.form = {}
      this.showlist()
    },

    // 表单刷新
    resertTable() {
      this.showlist(true)
      this.checkList = [
        "序号",
        "服务类型",
        "老人类别",
        "区域",
        "开始时间",
        "结束时间",
        "走访进度",
        "处理人",
        "创建时间",
        "操作",
      ]
      this.tableShow()
      // this.form = {}
    },

    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.showlist()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.showlist()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },

    // 刷新页面
    Resert() {
      this.reload()
    },

    // 表格列表
    showlist(s) {
      let params = {}
      if (s === true) {
        params = {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNo: this.pageNo,
          name: this.form.name,
          lifeArea: this.form.lifeArea,
          type: this.form.type,
          serviceStation: this.form.serviceStation,
          minzhengIndex: this.form.minzhengIndex,
          provinceId: this.form.provinceId,
          cityId: this.form.cityId,
          areaId: this.form.areaId,
          streetId: this.form.streetId,
          shequid: this.form.shequid,
        }
      }
      params = Object.assign({}, params)
      request({
        url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null) {
            this.tableDate = res.content.list
            this.total = res.content.count
          } else {
            this.tableDate = []
          }
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.rkld {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.rkldLeft {
  width: 234px;
  height: 100%;
  background: #37404f;
}

.rkldLeftLogo {
  background-color: rgb(55, 64, 79);
  height: 68px;
  width: 100%;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.rkldLeftLogoImage {
  width: 39px;
  margin-left: 20px;
  margin-right: 10px;
}

.rkldRight {
  flex: 1;
  height: 100%;
  width: calc(100% - 266px);
  background-color: #ffffff;
}

.rkldRightHead {
  border-bottom: 1px solid #f5f5f5;
  width: 100%;
  background-color: #ececec;
  height: 69px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mlIcon {
  height: 35px;
  width: 35px;
  font-size: 14px;
  margin-left: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 3px;
}

.mlIcon:hover {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar {
  display: none !important;
}

.rkldRightHeadRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 15px;
}

.demo-form-inline {
  padding: 0 5%;
}

.btnform {
  text-align: center;
}

.bodymsg {
  width: 140px;
  height: 40px;
  background-color: #ffb404;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 2px;
  margin-top: 20px;
  cursor: pointer;
}

.switchpage {
  display: inline-block;
  margin-bottom: 10px;
}

.activesiwtch {
  background-color: #d6d7d8;
}

.rkldRightHeadRightLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
}

.rkldRightHeadRightLeft img {
  margin-right: 5px;
}

.rkldRightContent {
  height: calc(100% - 70px);
  overflow-y: auto;
  margin: 20px;
}

.searchTj {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;
  margin: 5px;
}

.searchTjHead {
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: rgb(0, 0, 0);
  border-color: rgb(217, 217, 217);
  padding: 6px 15px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.searchTjContent {
  padding: 15px 20px 0px 5px;
  border: 1px solid rgb(217, 217, 217);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.searchTjContentDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.searchTjContentDivSpan {
  min-width: 58px;
  margin-right: 20px;
  font-size: 14px;
  margin-top: 10px;
}

.searchTjContentDivInput {
  width: 20%;
  min-width: 196px;
}

/deep/ .arrowDown {
  width: 28px;
  height: 28px;
  background: #edf2f0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -14px;
  transform: translate(-50%, 0px) 2s;
  border-radius: 50%;
  z-index: 2;
  cursor: pointer;
  // transition: 2s;
}

/deep/ .el-tabs__content {
  padding-bottom: 20px;
}

.searchButtonDiv {
  height: 54px;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: space-between;
}

.searchButtonDivLeft {
  display: flex;
}
/deep/ .el-button {
  border-radius: 4px;
  padding: 0px 8px !important;
  border: none;
  height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
  border-left-color: rgba(255, 255, 255, 0.5);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
  margin-top: 10px;
}

/deep/ .el-submenu__title i {
  color: #fff;
}

.el-submenu /deep/ .el-menu-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .el-submenu__title {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-menu-item {
  border-bottom: 1px solid #2c3342;
  background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
  border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
  .el-tabs--card
  > .el-tabs__header
  /deep/
  .el-tabs__item.is-active.is-closable {
  color: #0e2d5f;
}

/deep/ .el-menu .is-active {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .el-submenu {
  width: 234px !important;
}

/deep/ .el-menu-item:hover {
  color: rgb(255, 255, 255) !important;
  background-color: #437ae1 !important;
}

/deep/ .tabBtn {
  margin: 0px;
}

.rkld .el-menu-vertical-demo:not {
  background: rgb(55, 64, 79) !important;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
  background-color: #fafad2 !important;
  color: #000;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: #fafad2 !important;
}

.mapleft {
  margin-left: 10px;
  width: 200px;
  height: 400px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  p {
    line-height: 42px;
    text-align: center;
  }
}
// 弹框样式
/deep/ .el-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e6e6e6;
  }
  .el-dialog__footer {
    background: #e6e6e6;
  }
  // 弹框步骤条样式
  .el-step__icon.is-text {
    border-radius: 5px;
  }
  .is-finish .el-step__icon {
    background: #409eff;
  }
  .el-step__icon {
    width: auto;
    padding: 15px 20px;
    color: #ffffff;
    cursor: pointer;
    border: none;
    background: #c0c4cc;
  }
  .el-step {
    height: 40px;
    margin-bottom: 24px;
  }
  .el-step.is-horizontal .el-step__line {
    top: 16px;
  }
}
/deep/.dialog-footer {
  text-align: center;
  display: block;
}
// 上传图片
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .span_icon {
  margin: 0 10px;
}
.screen_container {
  display: flex;
  margin-left: auto;
  float: right;
  margin-top: 20px;
  margin-bottom: 5px;
}
/deep/.none {
  width: 55%;
  .el-input__inner {
    border: none;
  }
}
/deep/.dialog_container {
  padding-bottom: 15px;
}
/deep/.addressFrom {
  display: flex;
  margin-left: -50px;
  margin-bottom: 20px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    width: 140px;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
.addressFrom {
  display: flex;
  margin-left: -50px;
  margin-bottom: 20px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    width: 140px;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
</style>
